import MilestonesSerializer from './base';
import { isArray } from '@ember/array';

export default class MilestoneSet extends MilestonesSerializer {
  payloadKeyFromModelName(modelName) {
    return super
      .payloadKeyFromModelName(modelName)
      .replace('milestones/milestoneSet', 'milestoneset');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey(
      key.replace('milestoneset', 'milestones/milestoneSet'),
    );
  }

  normalizeArrayResponse(store, primaryModelClass, payload) {
    if (!isArray(payload.milestoneSets)) {
      // If the school has no Milestone Sets, Go may omit the empty key.
      payload.milestoneSets = [];
    }
    return super.normalizeArrayResponse(...arguments);
  }
}
